export const customers = (state = [], action) => {
  if (action.type === 'FETCH_CUSTOMERS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMERS') {
    return [];
  }
  return state;
};

export const customer = (state = {}, action) => {
  if (action.type === 'FETCH_CUSTOMER') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMER') {
    return {};
  }
  return state;
};

export const customerIds = (state = [], action) => {
  if (action.type === 'FETCH_CUSTOMER_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMER_IDS') {
    return [];
  }
  return state;
};
